import React from 'react';

export interface DisconnectTimerProps {
    active: boolean;
    secondsRemaining: number;
    disconnectedPlayerName: string | null;
}

/**
 * Full-screen overlay: countdown while the opponent is disconnected (server forfeit after 60s).
 */
export const DisconnectTimer: React.FC<DisconnectTimerProps> = ({
    active,
    secondsRemaining,
    disconnectedPlayerName,
}) => {
    if (!active) {
        return null;
    }

    const label = disconnectedPlayerName?.trim() || 'Opponent';

    return (
        <div className="disconnect_timer_overlay" role="status" aria-live="polite">
            <div className="disconnect_timer_card">
                <p className="disconnect_timer_title">{label} disconnected</p>
                <p className="disconnect_timer_sub">Player forfeit in</p>
                <p className="disconnect_timer_count" aria-label="Seconds remaining">
                    {secondsRemaining}
                </p>
                <p className="disconnect_timer_unit">seconds</p>
            </div>
        </div>
    );
};

export default DisconnectTimer;
